
import MyVideo from './video.vue';
export default {
  // install 是默认的方法。当外界在 use 这个组件的时候，就会调用本身的 install 方法，同时传一个 Vue 这个类的参数。
    
  install: function(Vue){

    Vue.component('MyVideo', MyVideo);

    let video = {
      /** 
             * 播放视频
             * @param {String} url 音视频地址
             */
      play(url) {
        Vue.prototype.$showModal.show({
          hideFooter: true,
          message: (h) => {
            return h('my-video', {
              props: {
                url: url
              },
            });
          },
        });
      },
    
      /** 
             * 关闭播放视频窗口
             */
      close() {
        Vue.prototype.$showModal.hide();
      }
    };
    Vue.prototype.$video = video;
    return video;
        
  }
};